import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  import EcoPopup from '@/vue/responsible-stay/components/EcoPopup.vue'
  import { CriteriaEnum } from '@/enums/criterias'

  interface IResponsibleStay {
    stationData: Record<string, any>
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsibleStay',
  props: {
    stationData: null
  },
  setup(__props: any) {

const props = __props as {
    stationData: Record<string, any>
  };

  

  const content = ref<{ [key: string]: string }>(window.content)
  const isCriteriaFloconVert = ref(false)
  const isCriteriaCleVerte = ref(false)
  const isPopupOpen = ref(false)

  const checkCriteria = (): void => {
    if (props.stationData?.criterias) {
      isCriteriaFloconVert.value = props.stationData.criterias.includes(
        CriteriaEnum.FLOCON_VERT
      )
    }
    if (window.lihe?.criteriasList) {
      isCriteriaCleVerte.value = window.lihe.criteriasList.includes(
        CriteriaEnum.CLE_VERTE
      )
    }
  }

  watch(
    () => props.stationData?.criterias,
    newCriterias => {
      if (newCriterias) {
        checkCriteria()
      }
    }
  )

  const togglePopup = () => {
    isPopupOpen.value = !isPopupOpen.value
  }

  const closePopup = () => {
    isPopupOpen.value = false
  }

return { __sfc: true,props, content, isCriteriaFloconVert, isCriteriaCleVerte, isPopupOpen, checkCriteria, togglePopup, closePopup, EcoPopup }
}

})